import * as React from 'react';
import * as _ from 'lodash';
import { Card } from 'react-toolbox/lib/card';
import { CardActions } from 'react-toolbox/lib/card';
import { CardHeader } from 'react-toolbox/lib/card';
import { CardTitle } from 'react-toolbox/lib/card';
import { CardText } from 'react-toolbox/lib/card';
import Button from 'react-toolbox/lib/button';
import TextInput from '../../../utils/common_components/textInput_form';
import { Field } from 'redux-form';
import Select from '../../../utils/common_components/select';
import Switch from '../../../utils/common_components/switch_form';
import DatePicker from '../../../utils/common_components/datepicker_form';
import TimePicker from '../../../utils/common_components/time_picker_form';
import moment from 'moment';
import Checkbox from '../../../utils/common_components/checkbox_form';
export default function () {
    function repeatFrequency1(frequency, frequencyIndex) {
        return React.createElement('div', { 'key': frequencyIndex }, React.createElement(Field, {
            'className': 'border-around w-100 p-t-0 m-b-20',
            'name': 'client_bookings[' + frequency.id + '].bookings',
            'component': Select,
            'label': frequency.__day + ' (' + moment(frequency.start_time, 'HH:mm:ss').format('h:mm a') + ' to ' + moment(frequency.end_time, 'HH:mm:ss').format('h:mm a') + ' )',
            'options': frequency.schedule_dates,
            'valueKey': 'id',
            'labelKey': 'name',
            'multi': true,
            ',': true
        }));
    }
    return React.createElement('div', { 'className': 'row center-xs' }, this.state.data_loaded ? React.createElement('form', {
        'className': 'col-xs-12 no-box-shadow bg-white',
        'onSubmit': this.props.handleSubmit(this.doSave),
        'key': '1200'
    }, React.createElement(Card, { 'className': 'no-box-shadow' }, React.createElement(CardTitle, {
        'title': 'Bookings for ' + this.props.group_class.name,
        'className': 'c-black form-title m-b-10'
    }), React.createElement(CardText, {}, React.createElement('div', { 'className': 'border-around m-b-20' }, React.createElement(Field, {
        'className': 'w-100 p-t-0 m-b-20',
        'name': 'client',
        'component': Select,
        'label': 'Practice Clients',
        'options': this.props.clientList,
        'disabled': this.props.bookedClientId,
        'valueKey': 'id',
        'labelKey': 'name',
        'simpleValue': true
    })), this.props.group_class.booking_type === 2 ? React.createElement('div', {
        'className': 'd-flex material-label text-left vertical-align m-b-5',
        'style': { alignItems: 'baseline' },
        'key': '2080'
    }, React.createElement('label', { 'className': 'm-r-10' }, 'Book entire series'), React.createElement(Field, {
        'name': 'entire_series',
        'component': Checkbox
    })) : null, !this.props.entire_series && this.props.group_class.booking_type === 2 ? React.createElement.apply(this, [
        'div',
        { 'key': '2440' },
        _.map(this.props.group_class.group_class_frequency, repeatFrequency1.bind(this))
    ]) : null, React.createElement('div', {}, React.createElement(Button, {
        'label': 'Book',
        'className': 'bg-success m-r-10',
        'disabled': this.props.pristine || this.props.submitting,
        'type': 'submit',
        'style': { height: 'fit-content !important' },
        'primary': true,
        'raised': true
    }), React.createElement(Button, {
        'label': 'Cancel',
        'onClick': this.props.closeBookingDialog,
        'className': 'bg-success-border',
        'primary': true,
        'raised': true
    }))))) : null);
}